import React from 'react';

import * as S       from './subscription-view.module.scss';
import { TileQkn }  from './tile-qkn/tile-qkn';
import { TileQem }  from './tile-qem/tile-qem';
import { SimpTile } from './tile-simp/simp-tile';
import { TileCoTerm } from './tile-coterm/coterm-tile';
import { TileBundle } from './tile-bundle/bundle-tile';
import { AdvertTile } from './tile-advert/advert-tile';
import { ViewWrapper }       from '../../common/view-wrapper';
import { useGlobalCtx }      from '../../../context/ctx-hook';
import { useOnPageChange }   from '../../../helpers/hooks/use-on-page-change';
import { getBillManagerType } from '../../../context/selectors/bill-selectors';
import * as ProductSelectors from '../../../context/selectors/product-selectors';
import { getQknSubscription } from '../../../context/selectors/bill-selectors';



const SubscriptionView = () => {
  const {state}   = useGlobalCtx();
  const IS_USA    = state.country === 'us';
  // console.log(state?.subscriptions);

  const coTermGrpIsOnlyQknOb = (subs) => {
    return subs.length === 2 && subs.every(sub => ProductSelectors.hasSpecificProducts(state, sub.coTermProductLines));
  };

  const BUNDLED_SUBS = state?.subscriptions?.bundles.filter(bundle => {
    const userSubscriptions = Object.keys(state?.subscriptions);
    if(!bundle?.bundleSub?.active && userSubscriptions.length <= 1) {
      return bundle;
    } else if (bundle?.bundleSub?.active) {
      return bundle;
    }
  });

  // Group all bundle sku's, then group again on their transaction id
  // const ALL_BUNDLED_SUBS = Object.values(state?.subscriptions).filter(sub => sub?.bundleInfo);
  // const BUNDLED_SUBS = ProductSelectors.groupByTxnIdAndPretendBundledSubsAreOneSubWhenTheyAreReallyArentAndOurApisSuck(ALL_BUNDLED_SUBS, state.skus);

  // console.log('ALL_BUNDLED_SUB', ALL_BUNDLED_SUBS);
  // console.log('BUNDLED_SUBS', BUNDLED_SUBS);
  const QKN_SUB_DATA = getQknSubscription(state, state?.country);
  const QKN_IS_IN_BUNDLE = QKN_SUB_DATA ? !!QKN_SUB_DATA?.bundleSub : false;
  // Group the co-term tiles together into a variable
  const ALL_COTERM_SUBS = QKN_IS_IN_BUNDLE ?
    Object.values(state?.subscriptions).filter(sub => sub?.isCoTerminus && !sub?.bundleInfo && !sub?.parentProductLineUriName)
    : Object.values(state?.subscriptions).filter(sub => sub?.isCoTerminus && !sub?.bundleInfo);
  let COTERM_SUBS = ProductSelectors.splitCotermGroupsAndActLikeQuickenAndObAreNotCotermWhenTheyReallyAre(ALL_COTERM_SUBS);

  // console.log('ALL_COTERM_SUBS:', ALL_COTERM_SUBS);
  // console.log('COTERM_SUBS:', COTERM_SUBS);
  // console.log('QKN_SUB_DATA:', QKN_SUB_DATA);
  // console.log('QKN_IS_IN_BUNDLE:', QKN_IS_IN_BUNDLE);

  // console.log('ALL_COTERM_SUBS', ALL_COTERM_SUBS);
  // console.log('COTERM_SUBS', COTERM_SUBS);

  // Group the single subscription tiles together
  // this HAS_QKN only checks for non-cotermed quickens
  const HAS_NON_CO_TERM_QKN = !!state?.subscriptions?.[IS_USA ? 'quicken-us' : 'quicken-ca'] && !state?.subscriptions?.[IS_USA ? 'quicken-us' : 'quicken-ca'].isCoTerminus;
  const HAS_QEM = !!state?.subscriptions?.['quicken-estate-manager'] && !state?.subscriptions?.['quicken-estate-manager'].isCoTerminus;
  const SIMP_SUBS = Object.values(state?.subscriptions).filter(sub =>{
    return (sub.productLineUriName == 'acme' || sub.productLineUriName == 'acme-google' || sub.productLineUriName == 'acme-apple' ) && !sub.isCoTerminus;
  });

  // Addon checks for advertisement tile
  const BM_TYPE = getBillManagerType(state);
  // Check if they have any quicken co-term on not
  const HAS_ANY_QKN = !!state?.subscriptions?.[IS_USA ? 'quicken-us' : 'quicken-ca'];
  // const HAS_QOB = !!state?.subscriptions?.['quicken-online-backup'];
  // const QKN_US_ACTIVE = Object.values(state?.subscriptions).filter(sub => sub.productLineUriName === 'quicken-us' && sub.active === true).length > 0;
  // const QEM_ACTIVE = Object.values(state?.subscriptions).filter(sub => sub.productLineUriName === 'quicken-estate-manager' && sub.active === true).length > 0;
  // const SHOW_ADVERT = HAS_ANY_QKN && QKN_SUB_ACTIVE && IS_USA && (BM_TYPE !== 'PAID' || !HAS_QOB);

  // const HAS_ANY_SIMP = !!state?.subscriptions?.['acme'] || !!state?.subscriptions?.['acme-google'] || !!state?.subscriptions?.['acme-apple'];
  // const SIMP_SUB_ACTIVE = Object.values(state?.subscriptions).filter(sub => (sub.productLineUriName === 'acme' || sub.productLineUriName === 'acme-apple' || sub.productLineUriName === 'acme-google' ) && sub.active === true).length > 0;

  const COTERM_IS_QKN_AND_QOB = ALL_COTERM_SUBS.filter(sub => ['quicken-us', 'quicken-ca', 'quicken-online-backup'].includes(sub.productLineUriName));
  const ACT_LIKE_COTERM_IS_NOT_COTERM = COTERM_IS_QKN_AND_QOB.length === 2 && COTERM_IS_QKN_AND_QOB.every(sub => ProductSelectors.hasSpecificProducts(state, sub.coTermProductLines));
  const QUICKEN_SUB = ACT_LIKE_COTERM_IS_NOT_COTERM ? HAS_ANY_QKN : HAS_NON_CO_TERM_QKN;





  // Product Line Ads logic
  const activeProductLines = state?.flatSubscriptions?.flatMap(sub => sub.productLineUriName);
  const QKN_US_ACTIVE = activeProductLines.includes('quicken-us');
  const QEM_ACTIVE = activeProductLines.includes('quicken-estate-manager');
  const ACME_ACTIVE = activeProductLines.some(activeSub =>{
    return activeSub === 'acme' || activeSub === 'acme-google' || activeSub === 'acme-apple';
  });
  const PRODUCT_LINE_ADS = [];
  // If they have a active Quicken US sub and no paid billmanager, push a BM ad
  if(
    !activeProductLines.includes('billmanager')
    && activeProductLines.includes('quicken-us')
  ) {
    PRODUCT_LINE_ADS.push('billmanager');
  }

  // If they have an active US subscription and they do not have online backup, show them OB ad
  if(
    activeProductLines.includes('quicken-us')
    && !activeProductLines.includes('quicken-online-backup')
  ) {
    PRODUCT_LINE_ADS.push('quicken-online-backup');
  }

  if(
    activeProductLines.includes('quicken-us')
    && !activeProductLines.includes('quicken-online-backup')
  ) {
    PRODUCT_LINE_ADS.push('quicken-online-backup');
  }

  if(
    (QKN_US_ACTIVE || ACME_ACTIVE) && !QEM_ACTIVE
  ) {
    PRODUCT_LINE_ADS.push('quicken-estate-manager');
  }

  // if(((HAS_ANY_SIMP && SIMP_SUB_ACTIVE) || QKN_US_ACTIVE) && !QEM_ACTIVE) {
  //   PRODUCT_LINE_ADS.push('quicken-estate-manager');
  // }
  // End product Line Ads logic

  // PRODUCT_LINE_ADS.push('billmanager');
  // console.log('HAS_NON_CO_TERM_QKN', HAS_NON_CO_TERM_QKN);
  // console.log('HAS_ANY_QKN', HAS_ANY_QKN);

  // console.log('COTERM_IS_QKN_AND_QOB', COTERM_IS_QKN_AND_QOB);
  // console.log('ACT_LIKE_COTERM_IS_NOT_COTERM', ACT_LIKE_COTERM_IS_NOT_COTERM);
  // console.log('QUICKEN_SUB', QUICKEN_SUB);

  useOnPageChange();

  return (
    <ViewWrapper testId="SUBSCRIPTION_AREA" title="Subscriptions">
      <div className={S.boxArea}>
        {state?.subscriptions?.bundles?.length > 0 && BUNDLED_SUBS?.map((bundleSub, i) => {
          return <TileBundle key={i} bundleSub={bundleSub} />;
        })}

        {COTERM_SUBS?.length > 0 && COTERM_SUBS?.map((coTermGrp, i) => {
          if(!coTermGrpIsOnlyQknOb(coTermGrp)) {
            return <TileCoTerm key={i} subs={coTermGrp} />;
          }
        })}

        {QUICKEN_SUB && <TileQkn/>}

        {IS_USA && SIMP_SUBS?.length > 0 && (
          <div className={S.simpArea}>
            {SIMP_SUBS?.map(sub => <SimpTile key={sub} product={sub.productLineUriName}/>)}
          </div>
        )}
        {HAS_QEM && <TileQem/>}

        {PRODUCT_LINE_ADS?.length > 0 &&
          <AdvertTile
            productLineAds={PRODUCT_LINE_ADS}
          />
        }
      </div>
    </ViewWrapper>
  );
};

SubscriptionView.displayName = 'SubscriptionView';

export { SubscriptionView };
